import React, { useState, useRef, useEffect } from "react";
import "./OtpDialog.css"; // File CSS per lo stile (crealo separatamente)
import { connect } from "react-redux";

const OtpDialog = ({ userData }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (userData.user.user && userData.user.user.codeValidation) {
      setIsDialogOpen(true);
      setTimeout(() => inputRefs.current[0]?.focus(), 0);
    }
  }, [userData]);
  const handleChange = (element, index) => {
    // Permette solo cifre
    if (isNaN(element.value)) return;

    // NUOVO: Resetta l'errore non appena l'utente inizia a scrivere
    setError("");

    // Aggiorna lo stato
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Sposta il focus al prossimo input se è stato inserito un valore
    if (element.value !== "" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Sposta il focus all'input precedente con backspace
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text");
    // Verifica che i dati incollati siano 6 cifre
    if (pasteData.length === 6 && !isNaN(pasteData)) {
      e.preventDefault();
      setError(""); // Resetta l'errore anche al paste
      const newOtp = pasteData.split("");
      setOtp(newOtp);
      inputRefs.current[5].focus(); // Mette il focus sull'ultimo campo
    }
  };

  const onConfirm = () => {
    const IDDetCliRef = userData.user.user.IdDetCliRef;
    setIsDialogOpen(false);
    // Aggiungi qui la logica da eseguire dopo la conferma del codice
    var body = JSON.stringify({ IDDetCliRef: IDDetCliRef });
    var endpoint = global.endpoint + "/pegaso/registraUltimoAccesso";
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
      });
  };
  const handleSubmit = () => {
    const finalCode = otp.join("");
    if (finalCode.length !== 6) {
      setError("Per favore, inserisci tutte e 6 le cifre.");
      return; // Interrompe l'esecuzione
    }

    if (userData.user.user.codeValidation === finalCode) {
      setError(""); // Pulisce eventuali errori precedenti
      // La funzione onConfirm non era definita, ora viene passata come prop
      if (onConfirm) onConfirm();
    } else {
      // Imposta il messaggio di errore, pulisce i campi e rimette il focus sul primo input
      setError("Codice errato, riprova.");
      setOtp(new Array(6).fill(""));
      inputRefs.current[0].focus();
    }
  };

  return (
    isDialogOpen && (
      <div className="dialog-backdrop" style={{ zIndex: 100 }}>
        <div className="dialog-content">
          <h2>Verifica il tuo account</h2>
          <p>Inserisci il codice a 6 cifre che hai ricevuto tramite email.</p>

          <div className="otp-input-container">
            {otp.map((data, index) => (
              <input
                key={index}
                type="text"
                className="otp-input"
                maxLength="1"
                value={data}
                onChange={(e) => handleChange(e.target, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={index === 0 ? handlePaste : undefined} // Gestisce l'incolla solo sul primo input
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>
          {error && <p className="error-message">{error}</p>}

          <button className="confirm-button" onClick={handleSubmit}>
            Conferma
          </button>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(OtpDialog);
